import { observer } from 'mobx-react-lite'
import { StudentAssignmentStep1 } from './StudentAssignmentStep1'
import { StudentAssignmentStep2 } from './StudentAssignmentStep2'
import { StudentAssignmentStep3 } from './StudentAssignmentStep3/StudentAssignmentStep3'
import { useStudentAssignmentCubit } from 'hooks/cubits/studentAssignment'
import classNames from 'classnames'
import { useTranslationTyped } from 'i18n/i18n'

export const StudentAssignmentStepsLoading = () => {
  return (
    <div className="flex h-full w-full grow flex-col items-center justify-start overflow-auto rounded-3xl bg-core-tertiary lg:w-auto">
      <div className="h-full max-h-full">
        <div className="flex h-full flex-col items-center justify-center overflow-auto">
          Loading...
        </div>
      </div>
    </div>
  )
}

export const StudentAssignmentSteps = observer(
  function StudentAssignmentSteps() {
    const cubit = useStudentAssignmentCubit()
    const { tt } = useTranslationTyped()

    const hasPreWorkMaterials = cubit.availableStudentMaterials.some(
      (m) => m.isPreWork
    )
    const hasPreMeetingQuiz = cubit.hasPreWorkQuiz
    const showGroupStep = !cubit.assignment.isSolo
    const showPreWorkStep = hasPreWorkMaterials || hasPreMeetingQuiz

    // steps renumber as earlier ones are hidden
    const stepLabels = [
      tt.student_assignment.step_1(),
      tt.student_assignment.step_2(),
      tt.student_assignment.step_3(),
    ]
    let stepIndex = 0
    const groupStepLabel = showGroupStep ? stepLabels[stepIndex++] : undefined
    const preWorkStepLabel = showPreWorkStep
      ? stepLabels[stepIndex++]
      : undefined
    const joinStepLabel = stepLabels[stepIndex]
    const divider = (
      <div className="w-[90%] max-w-[90%] border-t border-gray-200 md:w-[500px]" />
    )

    return (
      <div
        className={classNames(
          'flex w-full grow flex-col items-center justify-between rounded-3xl bg-core-tertiary p-3 md:h-full md:overflow-auto',
          {
            'gap-y-3': showPreWorkStep,
          }
        )}
      >
        {showGroupStep && (
          <StudentAssignmentStep1
            role="group"
            aria-label={groupStepLabel}
            className={classNames(
              'flex w-full flex-1 flex-col items-center justify-center py-5 text-center',
              {
                'mt-1': showPreWorkStep,
              }
            )}
          />
        )}
        {showPreWorkStep && (
          <>
            {showGroupStep && divider}
            <StudentAssignmentStep2
              role="group"
              aria-label={preWorkStepLabel}
              stepLabel={preWorkStepLabel ?? ''}
              className={classNames(
                'flex flex-1 flex-col items-center justify-center py-5 text-center',
                { 'mt-1': !showGroupStep }
              )}
              hasPreMeetingQuiz={hasPreMeetingQuiz}
              hasPreWorkMaterials={hasPreWorkMaterials}
            />
          </>
        )}
        {(showGroupStep || showPreWorkStep) && divider}
        <StudentAssignmentStep3
          key="step3-stable"
          stepLabel={joinStepLabel}
          role="group"
          aria-label={joinStepLabel}
          className="flex flex-1 flex-col items-center justify-center pt-4 pb-8 text-center"
        />
      </div>
    )
  }
)
